"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledProvisioningRecord = exports.DisableProvisioningRecordPayload = exports.ProvisioningRecordList = exports.QueriedProvisioningRecord = exports.ProvisioningRecordQuery = exports.CreateProvisioningRecordPayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../device"));
const field_1 = require("../../../../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Manufacturing.Schema';
exports.CreateProvisioningRecordPayload = effect_1.Schema.Struct({
    manufacturingSerialNumber: (0, field_1.nonEmpty)('Manufacturing serial number (MSN). Mandatory.'),
    dsn: (0, field_1.optionalString)('Device serial number. Mandatory for GBFC.'),
    assetTag: (0, field_1.optionalString)('Asset tag. Mandatory for Quench.'),
    sku: (0, field_1.optionalString)('SKU. Optional, not validated.'),
    fw: (0, field_1.optionalString)('Firmware version. Optional, not validated.'),
    factoryName: (0, field_1.optionalString)('Factory name. Optional, not validated.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateProvisioningRecordPayload`,
    description: 'Manufacturing data of a device to provision',
});
exports.ProvisioningRecordQuery = effect_1.Schema.Struct({
    dsn: (0, field_1.optionalString)('Device serial number'),
    msn: (0, field_1.optionalString)('Manufacturing serial number'),
    assetTag: (0, field_1.optionalString)('Asset tag'),
    includeDisabled: effect_1.Schema.optionalWith(effect_1.Schema.Literal('true', 'false'), { exact: true }).annotations({
        description: 'Pass `true` to include records disabled via DELETE, which are excluded by default, and to return their disabled fields. Any other value is read as false. Not a filter in its own right: another parameter is still required.',
    }),
    startDate: (0, field_1.optionalString)('Earliest manufacturedAt, inclusive. Either YYYY-MM-DD or an ISO date-time carrying an explicit offset. Anything else is 422.'),
    endDate: (0, field_1.optionalString)('Latest manufacturedAt, inclusive. Same formats as startDate. A bare date covers that whole day, ending at 23:59:59.999Z.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ProvisioningRecordQuery`,
    description: 'Filters of the provisioning record query',
});
const activeFields = effect_1.Struct.omit(Device.Manufacturing.ProvisioningRecord.fields, 'disabledAt', 'disabledReason', 'disabledBy', 'originalId');
exports.QueriedProvisioningRecord = effect_1.Schema.Struct({
    ...activeFields,
    disabledAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    disabledReason: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    disabledBy: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
    originalId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.QueriedProvisioningRecord`,
    description: 'A provisioning record from the query. The disabled fields are present, and null on an active record, only with includeDisabled=true.',
});
exports.ProvisioningRecordList = effect_1.Schema.Array(exports.QueriedProvisioningRecord).annotations({
    identifier: `${exports.NAMESPACE}.ProvisioningRecordList`,
    description: 'Provisioning records matching the query, ordered by manufacturedAt ascending',
});
exports.DisableProvisioningRecordPayload = effect_1.Schema.Struct({
    msn: (0, field_1.optionalString)('Manufacturing serial number. Mandatory unless `manufacturingSerialNumber` is sent; `msn` wins when both are.'),
    manufacturingSerialNumber: (0, field_1.optionalString)('Alias of `msn`, matching the field POST takes'),
    disabledReason: (0, field_1.nonEmpty)('Why the record is being released. Mandatory; a whitespace-only value is 422.'),
    dsn: (0, field_1.optionalString)('Device serial number. Verified when supplied, and the check runs on an active record only.'),
    assetTag: (0, field_1.optionalString)('Asset tag. Verified when supplied, and the check runs on an active record only.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.DisableProvisioningRecordPayload`,
    description: 'Provisioning record to disable',
});
exports.DisabledProvisioningRecord = effect_1.Schema.Struct({
    ...activeFields,
    disabledAt: (0, field_1.requiredString)('When the record was disabled'),
    disabledReason: (0, field_1.requiredString)('Why the record was disabled'),
    disabledBy: (0, field_1.requiredString)('The user id of the administrator who disabled it, or `factory-api-key` when the factory key was used'),
    originalId: (0, field_1.requiredString)('Id the record had before it was disabled'),
    createdAt: (0, field_1.optionalString)('When the stored document was created, stamped by the repository'),
    updatedAt: (0, field_1.optionalString)("The active record's updatedAt when DELETE returns the in-memory copy. The repository stamps a new one on the stored copy, and this response carries that stamp only when a later call reads the copy back."),
}).annotations({
    identifier: `${exports.NAMESPACE}.DisabledProvisioningRecord`,
    description: 'A disabled provisioning record',
});
//# sourceMappingURL=schema.js.map